function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
const solid = defineStyle((props)=>{
    const colorStyling = {
        color: 'white',
        bg: `${props.colorScheme}.500`
    };
    return _object_spread({
        alignItems: 'center',
        borderRadius: 'base',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        px: '2',
        py: '1',
        width: 'fit-content'
    }, colorStyling);
});
const outline = defineStyle((props)=>{
    let colorStyling = {
        color: `${props.colorScheme}.500`,
        borderColor: `${props.colorScheme}.300`,
        _dark: {
            color: `${props.colorScheme}.500`,
            borderColor: `${props.colorScheme}.800`
        }
    };
    if ([
        'neutral',
        'gray'
    ].includes(props.colorScheme)) {
        colorStyling = {
            color: `${props.colorScheme}.500`,
            borderColor: `${props.colorScheme}.300`,
            _dark: {
                color: `${props.colorScheme}.300`,
                borderColor: `${props.colorScheme}.500`
            }
        };
    }
    return _object_spread({
        borderRadius: 'base',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        px: '2',
        py: '1'
    }, colorStyling);
});
export const ThemedBadge = defineStyleConfig({
    variants: {
        solid,
        outline
    },
    defaultProps: {
        variant: 'solid'
    }
});
import { Badge as ChakraBadge } from "@chakra-ui/react";
/**
 * @deprecated Use Label instead
 */ export const Badge = ChakraBadge;

//# sourceMappingURL=Badge.js.map